<img [src]="`/public/logos/${tenantId()}.png`" [alt]="`${tenantId()} Logo`" />
